import classNames from "classnames";
import React, { ComponentProps, useRef } from "react";
import { mergeRefs } from "use-callback-ref";

import "./button.css";

export const Button = React.forwardRef<
	HTMLButtonElement,
	{
		raised?: boolean;
		round?: boolean;
		primaryColor?: boolean;
		compact?: boolean;
		/** Disable hover effect */
		noHover?: boolean;
	} & ComponentProps<"button">
>(
	(
		{
			className,
			children,
			raised = false,
			round = false,
			compact,
			primaryColor,
			noHover,
			...restProps
		},
		ref,
	) => {
		const cssClass = classNames("button", className, {
			"button--raised": raised,
			"button--primary": primaryColor && !raised,
			"button--round": round,
			"button--compact": compact && !raised && !round,
			"button--no-hover": noHover,
		});

		const innerRef = useRef<HTMLButtonElement>(null);

		return (
			<button
				ref={mergeRefs([ref, innerRef])}
				type="button"
				className={cssClass}
				{...restProps}
			>
				{children}
			</button>
		);
	},
);
Button.displayName = "Button";
